import md5 from "md5";

export const sign = (data) => {
    let sign = Object.keys(data).sort((a,b) => {
        return a > b ? 1 : -1
    }).reduce((prev, value) => {
        return prev + `${value}${data[value]}`
    }, '')
    return {
        ...data,
        sign: md5(sign + process.env.VUE_APP_SECURITY)
    }
}
